<template>
  <q-dialog
    v-model="showOrderProduct"
    class="be-order-product"
    data-cy="order-product-dialog"
    :maximized="$q.platform.is.mobile == true"
    persistent
    @shake="$emit('closePopUp')"
  >
    <div v-if="product !== null" class="row be-order-product-first-row">
      <div class="col text-white be-view-previous-product" @click="navigateBetweenProducts('left')">
        <q-btn flat icon="app:back" class="be-btn-round be-icon-12" />
      </div>
      <div class="col-auto" style="max-width: 1100px; width: 100%">
        <q-card class="popup-card" style="border-radius: 24px">
          <q-card-section class="be-order-product-card-section">
            <q-btn
              flat
              icon="app:close"
              class="be-btn-round be-icon-12"
              style="position: absolute; top: 20px; right: 20px; z-index: 9000"
              @click="$emit('closePopUp')"
            />
            <div>
              <div class="row">
                <div v-touch-swipe.mouse.horizontal="handleProductSwipeImage" class="col-md-6 col-sm-5 col-xs-12">
                  <div class="row">
                    <div class="col-auto">
                      <div
                        class="be-previous-product-img"
                        :style="{
                          'background-image':
                            'url(' +
                            $assetsUrl() +
                            ($props.previousProduct.photo !== null
                              ? $props.previousProduct.photo
                              : 'images/no-photo-food.jpg') +
                            ')'
                        }"
                      ></div>
                    </div>
                    <div class="col be-product-image">
                      <q-carousel
                        v-if="product.photo !== null"
                        v-model="currentImage"
                        animated
                        infinite
                        swipeable
                        :navigation="product.images.length > 0"
                        control-color="white"
                        navigation-icon="app:white-dot"
                        navigation-active-icon="app:green-dot"
                      >
                        <q-carousel-slide name="img-default" :img-src="$assetsUrl() + product.photo" />
                        <q-carousel-slide
                          v-for="(image, indexImage) in product.images"
                          :key="'img' + indexImage"
                          :name="'img' + indexImage"
                          :img-src="$assetsUrl() + image.path"
                        />
                      </q-carousel>
                      <q-img v-else class="be-product-no-photo" :src="$assetsUrl() + 'images/no-photo-food.jpg'" />
                    </div>
                    <div class="col-auto">
                      <div
                        class="be-next-product-img"
                        :style="{
                          'background-image':
                            'url(' +
                            $assetsUrl() +
                            ($props.nextProduct.photo !== null
                              ? $props.nextProduct.photo
                              : 'images/no-photo-food.jpg') +
                            ')'
                        }"
                      ></div>
                    </div>
                  </div>
                </div>
                <div v-touch-swipe.mouse.horizontal="handleProductSwipeContent" class="col-md-6 col-sm-7 col-xs-12">
                  <div class="be-main-lr">
                    <div class="be-product-name" v-html="product.name" />
                    <div
                      v-if="
                        product.allergens.length === 0 &&
                        product.nutritional_facts === null &&
                        product.ingredients === null
                      "
                      class="be-product-description"
                      style="margin-bottom: 5px; margin-top: 6px; display: block; white-space: break-spaces"
                      v-html="product.description"
                    />
                    <div
                      v-if="
                        product.allergens.length !== 0 ||
                        product.nutritional_facts !== null ||
                        product.ingredients !== null
                      "
                      class="text-grey-9"
                    >
                      <q-tabs
                        v-model="productContentTab"
                        dense
                        class="be-description-menu"
                        active-color="green"
                        indicator-color="green"
                        align="justify"
                        narrow-indicator
                        no-caps
                      >
                        <q-tab name="description" :label="$t('product.description')" />
                        <q-tab
                          v-if="product.ingredients !== null"
                          name="ingredients"
                          :label="$t('product.ingredients')"
                        />
                        <q-tab
                          v-if="product.allergens.length !== 0"
                          name="allergens"
                          :label="$t('product.allergens')"
                        />
                        <q-tab
                          v-if="product.nutritional_facts !== null"
                          name="nutritional_facts"
                          :label="$t('product.nutritional-facts')"
                        />
                      </q-tabs>
                      <q-tab-panels v-model="productContentTab" animated>
                        <q-tab-panel name="description" style="padding: 0">
                          <div
                            class="text text-grey-9 q-mt-sm"
                            style="display: block; white-space: break-spaces"
                            v-html="product.description"
                          />
                        </q-tab-panel>
                        <q-tab-panel name="ingredients" style="padding: 0">
                          <div
                            class="text text-grey-9 q-mt-sm"
                            style="display: block; white-space: break-spaces"
                            v-html="product.ingredients"
                          />
                        </q-tab-panel>
                        <q-tab-panel name="allergens" style="padding: 0">
                          <div v-for="(allergen, index) in product.allergens" :key="'allergen' + index">
                            <div class="row q-col-gutter-sm q-mt-md flex-center">
                              <div class="col-auto" style="padding-top: 0">
                                <q-icon :name="'app:allergen-' + allergen.id" style="width: 30px" />
                              </div>
                              <div class="col" style="padding-top: 0">
                                <div v-html="allergen.name" />
                              </div>
                            </div>
                          </div>
                        </q-tab-panel>
                        <q-tab-panel name="nutritional_facts" style="padding: 0">
                          <div v-if="product.nutritional_facts !== null">
                            <q-markup-table flat bordered dense class="q-mt-sm">
                              <thead>
                                <tr>
                                  <th class="text-center" colspan="3">
                                    <b
                                      >{{ $t('product.nutritional-facts') }}
                                      {{ product.nutritional_facts.reference_quantity }}</b
                                    >
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(nutrient, index) in product.nutritional_facts.nutrients"
                                  :key="'nutrient' + index"
                                >
                                  <td>
                                    <div v-if="nutrient.padding !== 0" style="display: inline-block; width: 15px" />
                                    {{ $capitalize(nutrient.name) }}
                                  </td>
                                  <td class="text-right">{{ Number(nutrient.quantity) }} {{ nutrient.unit_name }}</td>
                                  <td class="text-right">
                                    <div v-if="nutrient.daily_value !== null">{{ Number(nutrient.daily_value) }}%</div>
                                  </td>
                                </tr>
                              </tbody>
                            </q-markup-table>
                            <div v-html="product.nutritional_facts.observation" />
                          </div>
                        </q-tab-panel>
                      </q-tab-panels>
                    </div>
                    <div class="be-modifiers-scroll">
                      <div v-if="product.sizes.length > 0" style="margin-bottom: 10px">
                        <div class="q-pt-md q-pb-md be-modifiers">
                          <q-expansion-item default-opened>
                            <template #header="{ expanded }">
                              <q-item-section v-if="expanded" class="be-modifier-expanded">{{
                                $t('order-product.choose-option')
                              }}</q-item-section>
                              <q-item-section v-else class="be-modifier-collapsed">
                                <div>{{ $t('order-product.choose-option') }}</div>
                                <div class="be-modifier-expanded" v-html="selectedSize"></div>
                              </q-item-section>
                            </template>
                            <q-card>
                              <q-card-section style="padding-top: 0">
                                <div v-for="(size, index) in product.sizes" :key="'product-size' + index">
                                  <q-radio
                                    v-model="product.selected_size"
                                    :val="size.value"
                                    :label="size.label"
                                    class="be-icon-20"
                                    checked-icon="app:radio-checked"
                                    unchecked-icon="app:radio-unchecked"
                                    @update:model-value="changeSelectedSize"
                                  />
                                </div>
                              </q-card-section>
                            </q-card>
                          </q-expansion-item>
                        </div>
                        <q-list class="be-modifiers">
                          <q-expansion-item
                            v-for="(modifier, index) in sizeModifiers"
                            :key="'sizemodifier' + index"
                            default-opened
                          >
                            <template #header="{ expanded }">
                              <q-item-section
                                v-if="expanded || selectedOptions(modifier.id) === ''"
                                class="be-modifier-expanded"
                                >{{ modifier.name }}</q-item-section
                              >
                              <q-item-section v-else class="be-modifier-collapsed">
                                <div v-html="modifier.name"></div>
                                <div class="be-modifier-expanded" v-html="selectedOptions(modifier.id)"></div>
                              </q-item-section>
                            </template>
                            <q-card>
                              <q-card-section style="padding-top: 0">
                                <div
                                  v-for="(option, optionIndex) in modifier.options"
                                  :key="'sizeoption' + optionIndex"
                                >
                                  <div class="row">
                                    <div class="col">
                                      <q-checkbox
                                        v-if="modifier.max_quantity == 1"
                                        v-model="product.options"
                                        :disable="option.available == 0"
                                        :val="option"
                                        :label="option.name"
                                        color="green"
                                        :checked-icon="
                                          modifier.max_options == 1 ? 'app:radio-checked' : 'app:checkbox-checked'
                                        "
                                        :unchecked-icon="
                                          modifier.max_options == 1 ? 'app:radio-unchecked' : 'app:checkbox-unchecked'
                                        "
                                        :class="{
                                          'text-grey-6': option.available == 0,
                                          'text-black': option.available == 1,
                                          'be-icon-24': true
                                        }"
                                        @update:model-value="oneSelect(modifier, option)"
                                      />
                                      <div
                                        v-if="modifier.max_quantity > 1"
                                        :color="option.available == 0 ? 'grey-4' : 'black'"
                                        :class="{
                                          'be-option-name': true,
                                          'text-grey-6': option.available == 0,
                                          'text-black': option.available == 1
                                        }"
                                        style="padding-left: 10px"
                                        v-html="option.name"
                                      />
                                    </div>
                                    <div class="col-auto" style="white-space: nowrap">
                                      <div
                                        v-if="option.old_price"
                                        :class="{
                                          'be-option-price be-old-price q-mr-sm': true,
                                          'text-grey-6': option.available == 0,
                                          'text-black': option.available == 1
                                        }"
                                        style="display: inline-block"
                                        v-html="$formatCurrency(Number(option.old_price), currency)"
                                      />
                                      <div
                                        v-if="Number(option.price) != 0"
                                        :class="{
                                          'be-option-price': true,
                                          'text-grey-6': option.available == 0,
                                          'text-black': option.available == 1
                                        }"
                                        style="display: inline-block"
                                        v-html="$formatCurrency(Number(option.price), currency)"
                                      />
                                    </div>
                                    <div v-if="allowOrdering" class="col-auto">
                                      <div v-if="modifier.max_quantity > 1">
                                        <q-btn
                                          flat
                                          icon="app:minus"
                                          class="be-btn-round be-option-btn"
                                          :color="product.options.indexOf(option) == -1 ? 'grey-4' : 'black'"
                                          :disable="option.available == 0"
                                          @click="decrementOptionQuantity(option, modifier)"
                                        />
                                        <div class="be-option-quantity" v-html="option.quantity"></div>
                                        <q-btn
                                          flat
                                          icon="app:plus"
                                          class="be-btn-round be-option-btn"
                                          :disable="option.available == 0"
                                          :color="option.available == 0 ? 'grey-4' : 'black'"
                                          @click="incrementOptionQuantity(option, modifier)"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </q-card-section>
                            </q-card>
                          </q-expansion-item>
                        </q-list>
                      </div>
                      <q-list class="be-modifiers">
                        <q-expansion-item
                          v-for="(modifier, index) in product.modifiers"
                          :key="'modifier' + index"
                          :default-opened="Boolean(modifier.open) || modifier.required > 0"
                        >
                          <template #header="{ expanded }">
                            <q-item-section
                              v-if="expanded || selectedOptions(modifier.id) === ''"
                              class="be-modifier-expanded"
                              >{{ modifier.name }}</q-item-section
                            >
                            <q-item-section v-else class="be-modifier-collapsed">
                              <div v-html="modifier.name"></div>
                              <div class="be-modifier-expanded" v-html="selectedOptions(modifier.id)"></div>
                            </q-item-section>
                          </template>
                          <q-card>
                            <q-card-section style="padding-top: 0">
                              <div v-for="(option, optionIndex) in modifier.options" :key="'option' + optionIndex">
                                <div class="row">
                                  <div class="col">
                                    <q-checkbox
                                      v-if="modifier.max_quantity == 1"
                                      v-model="product.options"
                                      :disable="option.available == 0 || !allowOrdering"
                                      :val="option"
                                      :label="option.name"
                                      color="green"
                                      :checked-icon="
                                        modifier.max_options == 1 ? 'app:radio-checked' : 'app:checkbox-checked'
                                      "
                                      :unchecked-icon="
                                        modifier.max_options == 1 ? 'app:radio-unchecked' : 'app:checkbox-unchecked'
                                      "
                                      :class="{
                                        'text-grey-6': option.available == 0,
                                        'text-black': option.available == 1,
                                        'be-icon-24': true
                                      }"
                                      @update:model-value="oneSelect(modifier, option)"
                                    />
                                    <div
                                      v-if="modifier.max_quantity > 1"
                                      :color="option.available == 0 ? 'grey-4' : 'black'"
                                      :class="{
                                        'be-option-name': true,
                                        'text-grey-6': option.available == 0,
                                        'text-black': option.available == 1
                                      }"
                                      style="padding-left: 10px"
                                      v-html="option.name"
                                    />
                                  </div>
                                  <div class="col-auto" style="white-space: nowrap">
                                    <div
                                      v-if="option.old_price"
                                      :class="{
                                        'be-option-price be-old-price q-mr-sm': true,
                                        'text-grey-6': option.available == 0,
                                        'text-black': option.available == 1
                                      }"
                                      style="display: inline-block"
                                      v-html="$formatCurrency(Number(option.old_price), currency)"
                                    />
                                    <div
                                      v-if="Number(option.price) != 0"
                                      :class="{
                                        'be-option-price': true,
                                        'text-grey-6': option.available == 0,
                                        'text-black': option.available == 1
                                      }"
                                      style="display: inline-block"
                                      v-html="$formatCurrency(Number(option.price), currency)"
                                    />
                                  </div>
                                  <div v-if="allowOrdering" class="col-auto">
                                    <div v-if="modifier.max_quantity > 1">
                                      <q-btn
                                        flat
                                        icon="app:minus"
                                        class="be-btn-round be-option-btn"
                                        :color="product.options.indexOf(option) == -1 ? 'grey-4' : 'black'"
                                        :disable="option.available == 0"
                                        @click="decrementOptionQuantity(option, modifier)"
                                      />
                                      <div class="be-option-quantity" v-html="option.quantity"></div>
                                      <q-btn
                                        flat
                                        icon="app:plus"
                                        class="be-btn-round be-option-btn"
                                        :disable="option.available == 0"
                                        :color="option.available == 0 ? 'grey-4' : 'black'"
                                        @click="incrementOptionQuantity(option, modifier)"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </q-card-section>
                          </q-card>
                        </q-expansion-item>
                      </q-list>
                      <div v-if="product.out_of_stock === 0 && productPrice > 0" class="order-product-section">
                        <q-input
                          v-if="product.allow_instructions == 1"
                          v-model="product.informations"
                          type="textarea"
                          outlined
                          autogrow
                          dense
                          class="be-input-no-shadow"
                          :placeholder="$t('order-product.special-instructions')"
                          style="margin-top: 16px"
                        />
                        <div
                          v-if="product.informations.length > 3"
                          v-html="$t('order-product.instructions-extra-charge')"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="allowOrdering"
                    class="be-modal-footer"
                    style="border-bottom-right-radius: 24px !important; box-shadow: -6px -5px 16px #e4e5e8 !important"
                  >
                    <div
                      v-if="product.out_of_stock == 1"
                      class="text-h6 text-grey-6 text-center"
                      v-html="$t('products.unavailable')"
                    />
                    <div v-else class="row">
                      <div class="col-auto">
                        <q-btn
                          flat
                          icon="app:minus"
                          class="be-btn-round be-icon-12"
                          style="margin-top: 5px"
                          :color="product.quantity == 1 ? 'grey-4' : 'black'"
                          @click="product.quantity -= product.quantity > 1 ? 1 : 0"
                        />
                      </div>
                      <div class="col-auto text-center">
                        <div class="be-quantity" v-html="product.quantity"></div>
                      </div>
                      <div class="col-auto">
                        <q-btn
                          flat
                          icon="app:plus"
                          class="be-btn-round be-icon-12"
                          style="margin-top: 5px"
                          data-cy="order-product-increment-quantity"
                          @click="product.quantity++"
                        />
                      </div>
                      <div class="col-auto" style="width: 16px"></div>
                      <div class="col">
                        <q-btn
                          no-caps
                          flat
                          class="be-btn-l bg-black text-white be-icon-18 full-width img-no-filter btn-around"
                          align="around"
                          icon="app:cart"
                          :label="
                            $t('order-product.add-product-to-order') + ' ' + $formatCurrency(productPrice, currency)
                          "
                          data-cy="order-product-button"
                          @click="saveProduct"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-else
                    class="be-modal-footer text-center text-h6"
                    style="border-bottom-right-radius: 24px !important; box-shadow: -6px -5px 16px #e4e5e8 !important"
                  >
                    <div class="be-product-price">
                      <div v-if="product.out_of_stock == 0">
                        <span v-if="product.old_price" class="inline q-mr-sm be-old-price">
                          {{ $formatCurrency(Number(product.old_price), currency) }}
                        </span>
                        <span class="inline">
                          {{ $formatCurrency(productPrice, currency) }}
                          {{ product.unit !== null && product.unit !== '' ? ' /' + product.unit : '' }}
                        </span>
                      </div>
                      <div v-else v-html="$t('products.unavailable')" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
      <div class="col text-white be-view-next-product" @click="navigateBetweenProducts('right')">
        <q-btn flat icon="app:select" class="be-btn-round be-icon-12" />
      </div>
    </div>
  </q-dialog>
</template>

<script>
import { mapState, mapStores } from 'pinia'
import { useUserStore } from 'stores/user'
import { useCartStore } from 'stores/cart'
import { useMenusStore } from 'stores/menus'
import { useSettingsStore } from 'stores/settings'

export default {
  name: 'OrderProduct',
  props: {
    productId: {
      type: Number,
      default: null
    },
    previousProduct: {
      type: Object,
      default() {
        return {
          id: null,
          photo: null
        }
      }
    },
    nextProduct: {
      type: Object,
      default() {
        return {
          id: null,
          photo: null
        }
      }
    },
    currentProduct: {
      type: Object,
      default() {
        return {
          id: null
        }
      }
    },
    allowOrdering: {
      type: Boolean,
      default: true
    }
  },
  emits: ['orderProductSuccess', 'closePopUp', 'productSwipeLeft', 'productSwipeRight', 'showGeolocation'],
  data() {
    return {
      currentImage: 'img-default',
      product: null,
      defaultPhoto: null,
      oldPhoto: null,
      oldProductPrice: null,
      productContentTab: 'description',
      errors: {},
      showShareProduct: false,
      tableOrderingMode: false
    }
  },
  computed: {
    ...mapStores(useCartStore),
    ...mapState(useSettingsStore, {
      currency: store => store.localization.currency,
      supportWebp: 'accept_webp',
      trackers: 'trackers',
      companyName: store => store.website.name,
      companyId: store => store.website.company_id
    }),
    ...mapState(useUserStore, {
      userLogged: 'isLogged'
    }),
    ...mapState(useMenusStore, {
      selectedMenu: 'selected'
    }),
    productPrice() {
      let total = 0
      total += this.product.quantity * this.product.price
      this.product.options.forEach(option => {
        total += this.product.quantity * option.price * option.quantity
      })
      return Math.round(total * 100) / 100
    },
    sizeModifiers() {
      const selectedSize = this.product.sizes.find(size => size.value === this.product.selected_size)
      if (selectedSize && selectedSize.modifiers) {
        return selectedSize.modifiers
      } else {
        return []
      }
    },

    showOrderProduct: {
      get() {
        return this.$props.productId !== null
      },
      set(newValue) {
        this.$props.productId = newValue === false ? null : newValue
      }
    },
    selectedSize() {
      if (this.product.selected_size !== null) {
        const index = this.product.sizes.map(item => item.id).indexOf(this.product.selected_size)
        if (index !== -1) {
          return this.product.sizes[index].label
        }
      }
      return ''
    }
  },
  mounted() {
    if (process.env.BOOSTEAT_MODE === 'table-ordering') {
      this.tableOrderingMode = true
    }
    this.loadProduct(this.$props.productId)
  },
  methods: {
    handleProductSwipeImage({ ...info }) {
      if (this.product.images.length < 1) {
        if (this.$q.platform.is.mobile) {
          if (info.direction === 'right') {
            this.navigateBetweenProducts('left')
          } else if (info.direction === 'left') {
            this.navigateBetweenProducts('right')
          }
        }
      }
    },
    handleProductSwipeContent({ ...info }) {
      if (this.$q.platform.is.mobile) {
        if (this.nextProduct.id === null && this.previousProduct.id === null) {
          this.$router.push({ name: 'homepage' })
        }
        if (info.direction === 'right') {
          this.navigateBetweenProducts('left')
        } else if (info.direction === 'left') {
          this.navigateBetweenProducts('right')
        }
      }
    },
    navigateBetweenProducts(direction) {
      if (this.nextProduct.id === null && this.previousProduct.id === null) {
        this.$router.push({ name: 'homepage' })
      }
      if (direction === 'right') {
        this.$emit('productSwipeRight', this.nextProduct.id, this.product)
        this.loadProduct(this.nextProduct.id)
      } else {
        this.$emit('productSwipeLeft', this.previousProduct.id, this.product)
        this.loadProduct(this.previousProduct.id)
      }
    },
    saveProduct() {
      if (
        this.userLogged === false &&
        this.$q.localStorage.has('be_know_delivery_pickup') === false &&
        this.tableOrderingMode === false
      ) {
        this.$emit('showGeolocation', this.product)
      } else {
        let currentOnlyLater = 0
        // check only_later menus
        if (this.cartStore.products.length > 0) {
          currentOnlyLater = this.cartStore.only_for_later ? 1 : 0
          if (this.selectedMenu.only_later !== currentOnlyLater) {
            if (this.selectedMenu.only_later === 1) {
              this.$q.notify({
                message: this.$t('order-product.already-added-order-now'),
                position: 'center',
                color: 'negative',
                timeout: 5000
              })
              return
            }
          }
        } else {
          currentOnlyLater = this.selectedMenu.only_later
        }
        let selectedOptions = 0
        let totalQuantity = 0
        let error = false
        // check required modifiers
        this.product.modifiers.forEach(modifier => {
          if (modifier.required > 0 && error === false) {
            selectedOptions = 0
            this.product.options.forEach(option => {
              if (Number(option.modifier_id) === Number(modifier.id)) {
                selectedOptions += 1
                totalQuantity += Number(option.quantity)
              }
            })
            if (Number(modifier.required) > selectedOptions) {
              this.$q.notify({
                message: this.$t('order-product.min-options-notification', {
                  name: modifier.name,
                  options: modifier.required
                }),
                position: 'center',
                color: 'negative',
                timeout: 2000
              })
              error = true
            } else if (modifier.min_total_quantity !== null && totalQuantity < modifier.min_total_quantity) {
              error = true
              this.$q.notify({
                message: this.$t('order-product.min-quantity-notification', {
                  quantity: modifier.min_total_quantity,
                  name: modifier.name
                }),
                position: 'top',
                color: 'negative',
                timeout: 2000
              })
            }
          }
        })
        // check required modifiers for sizes
        if (this.sizeModifiers !== 'undefined') {
          this.sizeModifiers.forEach(modifier => {
            if (modifier.required > 0 && error === false) {
              selectedOptions = 0
              this.product.options.forEach(option => {
                if (Number(option.modifier_id) === Number(modifier.id)) {
                  selectedOptions += 1
                  totalQuantity += Number(option.quantity)
                }
              })
              if (Number(modifier.required) > selectedOptions) {
                this.$q.notify({
                  message: this.$t('order-product.min-options-notification', {
                    name: modifier.name,
                    options: modifier.required
                  }),
                  position: 'center',
                  color: 'negative',
                  timeout: 2000
                })
                error = true
              } else if (modifier.min_total_quantity !== null && totalQuantity < modifier.min_total_quantity) {
                error = true
                this.$q.notify({
                  message: this.$t('order-product.min-quantity-notification', {
                    quantity: modifier.min_total_quantity,
                    name: modifier.name
                  }),
                  position: 'top',
                  color: 'negative',
                  timeout: 2000
                })
              }
            }
          })
        }
        if (error === false) {
          if (Number.isNaN(this.product.quantity) || Number(this.product.quantity) <= 0) {
            this.product.quantity = 1
          }
          this.cartStore.$patch({
            only_for_later: currentOnlyLater === 1
          })
          this.cartStore
            .addProduct(this.product)
            .then(() => {
              // track add to cart event
              if (this.$q.localStorage.has('be_cookie_consent')) {
                try {
                  const acceptedCookies = this.$q.localStorage.getItem('be_cookie_consent')
                  Object.keys(this.trackers).forEach(type => {
                    if (type === 'gtag' && acceptedCookies.statistically) {
                      this.$gtag.event('add_to_cart', {
                        items: [
                          {
                            id: this.product.id,
                            name: this.product.name,
                            quantity: this.product.quantity,
                            price: this.product.price
                          }
                        ]
                      })
                    } else if (
                      type === 'gtag-ads' &&
                      this.trackers['gtag-ads'].add_to_cart !== null &&
                      acceptedCookies.marketing
                    ) {
                      this.$gtag.event('conversion', {
                        send_to: this.trackers[type].add_to_cart,
                        value: Number(this.product.price * this.product.quantity),
                        currency: this.currency
                      })
                    } else if (type === 'fbpixel' && acceptedCookies.marketing) {
                      fbq('track', 'AddToCart', {
                        content_name: this.product.name,
                        content_ids: [this.product.id],
                        content_type: 'product',
                        value: Number(this.product.price) * Number(this.product.quantity),
                        currency: this.currency
                      })
                    }
                  })
                  if (acceptedCookies.performance) {
                    this.$amplitude.track({
                      event_type: '[BE] Cart product added',
                      event_properties: {
                        productId: this.product.id,
                        productName: this.product.name,
                        productQuantity: this.product.quantity,
                        productPrice: this.product.price,
                        companyId: this.companyId,
                        companyName: this.companyName
                      }
                    })
                  }
                } catch (err) {
                  // to do
                }
              }
              this.$emit('orderProductSuccess')
            })
            .catch(error => {
              if (this.cartStore.group_order && typeof error.message !== 'undefined' && error.status === 'ERR') {
                this.$router.push(`/group-orders/cancelled?message=${error.message}`)
              }
            })
        }
      }
    },
    oneSelect(modifier, option) {
      if (modifier.options.length > 1) {
        let optionIndex = -1
        if (modifier.max_options === 1) {
          modifier.options.forEach(item => {
            if (item.id !== option.id) {
              optionIndex = this.product.options.indexOf(item)
              if (optionIndex !== -1) {
                this.product.options.splice(optionIndex, 1)
              }
            }
          })
        } else {
          let optionExists = 0
          let checkedIndex = 0
          modifier.options.forEach(item => {
            optionIndex = this.product.options.indexOf(item)
            if (optionIndex !== -1) {
              optionExists += 1
              if (item.id === option.id) {
                checkedIndex = optionIndex
              }
            }
          })
          if (optionExists > modifier.max_options) {
            this.product.options.splice(checkedIndex, 1)
            this.$q.notify({
              message: this.$t('order-product.max-options', { options: modifier.max_options }),
              position: 'center',
              color: 'negative',
              timeout: 2000
            })
          }
        }
      }
    },
    incrementOptionQuantity(option, modifier) {
      option.quantity = Number(option.quantity) + 1
      this.checkQuantity(option, modifier)
    },
    decrementOptionQuantity(option, modifier) {
      if (option.quantity > 0) {
        option.quantity = Number(option.quantity) - 1
        this.checkQuantity(option, modifier)
      }
    },
    checkQuantity(option, modifier) {
      const maxQuantity = modifier.max_quantity
      let showNotification = false

      // add or remove option
      const optionIndex = this.product.options.map(item => item.id).indexOf(option.id)
      if (optionIndex === -1 && Number(option.quantity) > 0) {
        this.product.options.push(option)
      } else if (optionIndex !== -1 && Number(option.quantity) === 0) {
        this.product.options.splice(optionIndex, 1)
      }

      if (modifier.max_total_quantity !== null) {
        let totalQuantity = 0
        this.product.options.forEach(item => {
          if (item.modifier_id === modifier.id) {
            totalQuantity += Number(item.quantity)
          }
        })
        if (totalQuantity > modifier.max_total_quantity) {
          showNotification = true
          option.quantity = Number(option.quantity) - (Number(totalQuantity) - Number(modifier.max_total_quantity))
          // remove option if quantity is 0
          if (Number(option.quantity) === 0) {
            this.product.options.splice(optionIndex, 1)
          }
          this.$q.notify({
            message: this.$t('order-product.max-quantity', { quantity: modifier.max_total_quantity }),
            position: 'center',
            color: 'negative',
            timeout: 2000
          })
        }
      }

      if (showNotification === false && Number(option.quantity) > Number(maxQuantity)) {
        option.quantity = maxQuantity
        this.$q.notify({
          message: this.$t('order-product.max-quantity', { quantity: maxQuantity }),
          position: 'center',
          color: 'negative',
          timeout: 2000
        })
      }
    },
    changeSelectedSize() {
      this.product.options = []
      this.product.modifiers.forEach(modifier => {
        modifier.options.forEach(option => {
          option.quantity = modifier.max_quantity !== null && modifier.max_quantity > 1 ? 0 : 1
        })
      })
      this.sizeModifiers.forEach(modifier => {
        modifier.options.forEach(option => {
          option.quantity = modifier.max_quantity !== null && modifier.max_quantity > 1 ? 0 : 1
        })
      })
      this.product.price = Number(this.product.sizes.find(size => size.value === this.product.selected_size).price)
    },
    loadProduct(id) {
      if (id !== null) {
        this.$q.loading.show()
        this.currentImage = 'img-default'
        let filtersQuery = ''
        if (this.$q.cookies.has('translate_language') && this.$q.cookies.get('translate_language').length === 5) {
          filtersQuery += `?translate_language=${this.$q.cookies.get('translate_language')}`
        }
        this.$axios
          .get(`public/products/${id}${filtersQuery}`)
          .then(response => {
            this.$q.loading.hide()
            this.product = response.data
            window.history.replaceState(
              {},
              this.product.name,
              `${process.env.VUE_ROUTER_BASE}p/${this.product.url}/${this.product.id}`
            )
            this.defaultPhoto = this.product.photo
            this.oldPhoto = this.product.photo
            let deleteProductImage = null
            this.product.images.forEach((item, index) => {
              if (item.view_product === 1) {
                this.product.photo = item.path
                this.oldPhoto = item.path
                deleteProductImage = index
              }
            })
            if (deleteProductImage !== null) {
              this.product.images.splice(deleteProductImage, 1)
            }
            this.product.price = Number(this.product.price)
            this.oldProductPrice = Number(this.product.price)
            if (this.product.sizes.length > 0) {
              this.changeSelectedSize()
            }
            this.product.modifiers.forEach(modifier => {
              if (modifier.required === 1 && modifier.options.length === 1) {
                this.product.options.push(modifier.options[0])
              }
            })
            if (
              this.$props.currentProduct !== null &&
              this.$props.currentProduct.id !== null &&
              (this.$props.currentProduct.price === this.product.price ||
                (this.product.sizes.length > 0 &&
                  JSON.stringify(this.product.sizes) === JSON.stringify(this.$props.currentProduct.sizes)))
            ) {
              const currentModifiers = this.$props.currentProduct.modifiers.map(item => ({
                id: item.id,
                options: item.options.map(option => ({ id: option.id, price: option.price }))
              }))
              const responseModifiers = this.product.modifiers.map(item => ({
                id: item.id,
                options: item.options.map(option => ({ id: option.id, price: option.price }))
              }))
              if (JSON.stringify(currentModifiers) === JSON.stringify(responseModifiers)) {
                this.product = this.$props.currentProduct
                this.saveProduct()
                return true
              }
            }
            if (this.$q.localStorage.has('be_cookie_consent')) {
              try {
                const acceptedCookies = this.$q.localStorage.getItem('be_cookie_consent')
                Object.keys(this.trackers).forEach(type => {
                  if (type === 'gtag' && acceptedCookies.statistically) {
                    this.$gtag.event('view_item', {
                      currency: this.currency,
                      value: this.product.price,
                      items: [
                        {
                          item_id: this.product.id,
                          item_name: this.product.name,
                          price: this.product.price,
                          currency: this.currency
                        }
                      ]
                    })
                  } else if (type === 'fbpixel' && acceptedCookies.marketing) {
                    fbq('track', 'ViewContent', {
                      content_name: this.product.name,
                      content_ids: [this.product.id],
                      content_type: 'product',
                      value: this.product.price,
                      currency: this.currency
                    })
                  }
                })
                if (acceptedCookies.performance && this.$amplitude !== null) {
                  this.$amplitude.track({
                    event_type: '[BE] Product viewed',
                    event_properties: {
                      productId: this.product.id,
                      productName: this.product.name,
                      productPrice: this.product.price,
                      companyId: this.companyId,
                      companyName: this.companyName
                    }
                  })
                }
              } catch (err) {
                if (process.env.NODE_ENV === 'development') {
                  console.log(err)
                }
              }
            }
          })
          .catch(() => {
            this.$q.loading.hide()
            this.product = null
          })
      } else {
        this.product = null
      }
    },
    mouseHoverImageEnter() {
      this.oldPhoto = this.product.photo
      this.product.images.forEach(item => {
        if (item.view_product_hover === 1) {
          this.product.photo = item.path
        }
      })
    },
    mouseHoverImageLeave() {
      this.product.photo = this.oldPhoto
    },
    selectedOptions(modifierId) {
      let result = ''
      this.product.options.forEach(option => {
        if (option.modifier_id === modifierId) {
          result += result !== '' ? ', ' : ''
          result += option.name
        }
      })
      return result
    }
  }
}
</script>
